<div class="process-step-outlet" >

    <div #title class="flex-row flex--align-center flex--justify-between padding-standard border-gray-bottom ">

        <h4 class="mat-headline-6 margin-none " >{{'ss-entities.activity.display-plural' | translate}}</h4>

        <mat-form-field id="signing-order" class="col-width">
            <mat-label>{{'ss-entities.process.signing-order' |translate}}</mat-label>
            <mat-select [value]="valueObs | async" (valueChange)="processSigningOrderSubject.next($event.value)">
                <mat-option *ngFor="let item of signingOrderTypeDataSource" [value]="item">
                    {{item.display | translate}}
                </mat-option>
            </mat-select>

        </mat-form-field>
        
        

    </div>
    
    
    <ss-activity-collection 
        *ngIf="(processSigningOrderSubject | async)!==ESigningOrderType.paralel;else unordered"
        fixedScroll 
        [otherElements]="append([title,pRef,divRef])" 
        [baseElement]="baseElement" 
        class="padding-standard"
    >
    </ss-activity-collection>

    <ng-template #unordered>
        <ss-activity-collection-unordered
            fixedScroll 
            [otherElements]="append([title,pRef,divRef])" 
            [baseElement]="baseElement" 
            class="padding-standard"
        >

        </ss-activity-collection-unordered>
    </ng-template>
    

    <p #pRef class="error-text margin-none padding-standard">
        <span *ngIf="showNoActivitesErrorObs | async">{{'ss-process-wizard.activity.no-activities' | translate}}

        </span>
    </p>

    <div #divRef class="flex-row gap-standard padding-standard">
        <button 
            mat-button 
            color="primary" 
            class="text-underline" 
            (click)="addNewActivity()" 
            libLoaderButton
            [keys]="['activity.insert']"
        >
            {{ "ss-entities.activity.add" | translate }}
            </button>

        <button 
                mat-button 
                color="primary" 
                class="text-underline"  
                (click)="addSelf()" 
                libLoaderButton
                [keys]="['activity.insert-self']"
            >
            {{ "ss-entities.activity.add-self" | translate }}
        </button>
    </div>

</div>